import { jsx as _jsx } from "react/jsx-runtime";
import { GRID_UNIT } from '../../../../utilities/grid';
import { Margin } from '../../../../utilities/margin';
import { Alert } from '../../../Alert';
export var Blockquote = function (_a) {
  var children = _a.children,
    alertType = _a.alertType;
  return _jsx(Margin, {
    top: GRID_UNIT,
    bottom: GRID_UNIT,
    children: _jsx(Alert, {
      type: alertType,
      message: children
    })
  });
};